let curriculum = {};
export const setCurriculum = (c) => { curriculum = c; };
export const getCurriculum = () => curriculum;

let audioMap = {};
export const setAudioMap = (a) => { audioMap = a; };
export const getAudioMap = () => audioMap;

let imageMap = {};
export const setImageMap = (i) => { imageMap = i; };
export const getImageMap = () => imageMap;
